import { useEffect, useCallback } from 'react';
import type { Atom } from 'jotai';
import { atom, useAtom } from 'jotai';
import { prompts } from '~/services';

const messagesAtom = atom(null);
export function useMessagesAPI() {
    const [messagesAPI] = useAtom(messagesAtom);

    return messagesAPI;
}

export function useSetMessagesAPI(messagesAPI: any) {
    const [, setMessagesAPI] = useAtom(messagesAtom);

    useEffect(() => {
        setMessagesAPI(messagesAPI);
    }, [messagesAPI, setMessagesAPI]);
}

const displayTokens = atom(0);
export function useDisplayTokens() {
    const [tokens, setTokens] = useAtom(displayTokens);

    const decreaseTokens = useCallback(() => {
        setTokens(Math.max(0, tokens - 1));
    }, [setTokens, tokens]);

    return { decreaseTokens, setTokens, tokens };
}

export function useDialog(atom: Atom<boolean>) {
    const [isOpened, setIsOpened] = useAtom(atom);
    const closeDialog = useCallback(() => setIsOpened(false), [setIsOpened]);
    const openDialog = useCallback(() => setIsOpened(true), [setIsOpened]);
    const toggleDialog = useCallback(
        () => setIsOpened(!isOpened),
        [setIsOpened, isOpened],
    );

    return {
        isOpened,
        openDialog,
        closeDialog,
        toggleDialog,
        setIsOpened,
    };
}

export function useGetPromptsTemplates() {
    return prompts;
}
